/**
 * Extend a Link mark (Mantine's or plain @tiptap/extension-link) to preserve
 * the button marker attributes and the inline style, so a button inserted as
 * raw HTML round-trips through ProseMirror without losing its styling.
 */
export const withButtonAttrs = (LinkExtension) =>
  LinkExtension.extend({
    addAttributes() {
      return {
        ...this.parent?.(),
        "data-email-button": {
          default: null,
          parseHTML: (el) => el.getAttribute("data-email-button"),
          renderHTML: (attrs) =>
            attrs["data-email-button"]
              ? { "data-email-button": attrs["data-email-button"] }
              : {},
        },
        "data-bg": {
          default: null,
          parseHTML: (el) => el.getAttribute("data-bg"),
          renderHTML: (attrs) =>
            attrs["data-bg"] ? { "data-bg": attrs["data-bg"] } : {},
        },
        "data-color": {
          default: null,
          parseHTML: (el) => el.getAttribute("data-color"),
          renderHTML: (attrs) =>
            attrs["data-color"] ? { "data-color": attrs["data-color"] } : {},
        },
        style: {
          default: null,
          parseHTML: (el) => el.getAttribute("style"),
          renderHTML: (attrs) => (attrs.style ? { style: attrs.style } : {}),
        },
      };
    },
  });
